import { useCssHandles } from '../../../utils/functions';
import Collapsible from './Collapsible';

const CSS_HANDLES = ['submenuAccordion'];

const SubmenuAccordion = ({ isOpen, blockClass, children }) => {
	const { handles } = useCssHandles('vtex-menu-2-x', CSS_HANDLES, blockClass);

	return (
		<Collapsible open={isOpen}>
			<section className={`${handles.submenuAccordion} w-100 flex pl4 flex`}>{children}</section>
		</Collapsible>
	);
};

export default SubmenuAccordion;
